<template>
  <section>
    <!-- "header" content other pages -->
    <header-content-geral
      :topSpace="busTopSpace"
    />

    <!-- second frame >> content -->
    <second-frame/>

    <!-- separator -->
    <!-- <section
      class="separator bg-purple w-100"
    /> -->

    <!-- fourth frame >> content -->
    <!-- <fourth-frame/> -->

    <!-- fifth frame >> content -->
    <fifth-frame/>

    <!-- newsletter container -->
    <section class="w-100 bg-gd-purple px-3">
      <newsletter
        class="shadow-lg position-relative"
        style="top: -50px;"
      />
    </section>
  </section>
</template>

<script>
// all
import HeaderContentGeral from '@/components/HeaderContentGeral'
import Newsletter from '@/components/Newsletter'

// about
import AboutSecondFrame from '@/components/about/AboutSecondFrame'

import AboutFifthFrame from '@/components/about/AboutFifthFrame'

export default {
  props: {
    busTopSpace: {
      type: String, 
      required: true
    }
  },
  components: {
    'header-content-geral': HeaderContentGeral,
    'second-frame': AboutSecondFrame,
    //'fourth-frame': AboutFourthFrame,
    'fifth-frame': AboutFifthFrame,
    'newsletter': Newsletter
  }
}
</script>

<style lang="scss">
  .separator {
    height: 30vh;
  }

  @media screen and (max-width: 768px) {
    .separator, .img-second-frame { display: none; }
    .second-frame { margin-bottom: 50px; }
  }
</style>
